import React from 'react';
import './AutoMax.scss';
import AutoMax from './AutoMax';

const AutoMaxGrouping = ({
  autoMaxOwnedIRATransactions,
  autoMaxPOAIRATransactions,
  type,
}) => {
  return (
    <div>
      {autoMaxOwnedIRATransactions.ownedFunds.length > 0 && (
        <div className="automax-container">
          <AutoMax
            funds={autoMaxOwnedIRATransactions.ownedFunds}
            showEdit={true}
            type={type}
          />
        </div>
      )}
      {Object.keys(autoMaxPOAIRATransactions).length > 0 &&
        Object.values(autoMaxPOAIRATransactions).map((autoMax) => {
          return Object.values(autoMax)?.map((fund, i) => {
            return (
              <div className="automax-container" key={i}>
                <AutoMax funds={fund} showEdit={false} type={type} />
              </div>
            );
          });
        })}
    </div>
  );
};

export default AutoMaxGrouping;
